import _ from "lodash";

export const getDepositConfigData = state => _.get(state,['deposit','depositConfig'],null)
export const getDepositManualPaymentSupportedCurrencies = deposit => _.get(deposit,['manual_payment','supported_currencies'],'')
export const getDepositOnlinePaymentSupportedCurrencies = deposit => _.get(deposit,['online_payment','supported_currencies'],'')
export const getDepositConfigAttributes = depositConfig => _.get(depositConfig,['attributes'],[])

//History
export const getEDepositAdditionalCharges = (eDeposit) =>
  _.get(eDeposit, ["additional_charges", "value"], "");
export const getEDepositCdsBranchCode = (eDeposit) => _.get(eDeposit, "cds_branch_code", "");
export const getEDepositCdsNumber = (eDeposit) => _.get(eDeposit, "cds_number", "");
export const getEDepositClientCode = (eDeposit) => _.get(eDeposit, "client_code", "");
export const getEDepositClientRemark = (eDeposit) => _.get(eDeposit, "client_remarks", "");
export const getEDepositCurrencyCode = (eDeposit) => _.get(eDeposit, ["currency_code", "value"], "");
export const getEDepositDepositAmount = (eDeposit) => _.get(eDeposit, ["deposit_amount", "full_text"], "");
export const getEDepositCreatedAtValue = (eDeposit) => _.get(eDeposit, ["transaction_date", "value"], "");
export const getEDepositCreatedAtDateTimeValue = (eDeposit) => _.get(eDeposit, ["transaction_datetime", "text"], "");
export const getEDepositId = (eDeposit) => _.get(eDeposit, "id", "");
export const getEDepositReference = (eDeposit) => _.get(eDeposit, "reference", "");
export const getEDepositStatusText = (eDeposit) => _.get(eDeposit, ["status", "text"], "");
export const getEDepositStatusValue = (eDeposit) => _.get(eDeposit, ["status", "value"], "");
export const getEDepositTotalText = (eDeposit) => _.get(eDeposit, ["total", "full_text"], "");
export const getEDepositTypeText = (eDeposit) => _.get(eDeposit, ["type", "text"], "");
export const getEDepositTypeValue = (eDeposit) => _.get(eDeposit, ["type", "value"], "");
export const getEDepositManualPaymentItems = (eDeposit) => _.get(eDeposit, ["manual_payment_items"], []);
export const getEDepositOnlinePaymentItems = (eDeposit) => _.get(eDeposit, ["online_payment_item"], null);
export const getEDepositAdditionalChargeFullText = (eDeposit) => _.get(eDeposit, ["additional_charges",'full_text'], null);

// manual payment
export const getManualPaymentAmountValue = (manualPayment) => _.get(manualPayment, ["amount", "value"], 0);
export const getManualPaymentAmountText = (manualPayment) =>
  _.get(manualPayment, ["amount", "full_text"], "");
export const getManualPaymentBankReferenceNumber = (manualPayment) =>
  _.get(manualPayment, ["bank_reference_number"], "");
export const getManualPaymentBankTransactionDateValue = (manualPayment) =>
  _.get(manualPayment, ["bank_transaction_date", "value"], "");
export const getManualPaymentBankTransactionTime = (manualPayment) =>
  _.get(manualPayment, ["bank_transaction_time"], "");
export const getManualPaymentChequeDate = (manualPayment) =>
  _.get(manualPayment, ["cheque_date", "value"], "");
export const getManualPaymentChequeNo = (manualPayment) => _.get(manualPayment, ["cheque_no"], "");
export const getManualPaymentDepositCompanyBankName = (manualPayment) =>
  _.get(manualPayment, ["deposit_company_bank", "display_name"], "");
export const getManualPaymentDepositCompanyBankAccount = (manualPayment) =>
  _.get(manualPayment, ["deposit_company_bank", "bank_account"], "");
export const getManualPaymentDocumentPublicUrl = (manualPayment) =>
  _.get(manualPayment, ["document", "public_url"], "");
export const getManualPaymentDraweeBankName = (manualPayment) =>
  _.get(manualPayment, ["drawee_bank", "name"], "");
export const getManualPaymentDraweeBankAccount = (manualPayment) =>
  _.get(manualPayment, ["drawee_bank_account"], "");
export const getManualPaymentStatusValue = (manualPayment) => _.get(manualPayment, ["status", "value"], "");
export const getManualPaymentStatusText = (manualPayment) => _.get(manualPayment, ["status", "text"], "");
export const getManualPaymentTypeText = (manualPayment) => _.get(manualPayment, ["type", "text"], "");

//online payment
export const getOnlinePaymentStatusValue = (onlinePayment) => _.get(onlinePayment, ["status", "value"], "");
export const getOnlinePaymentStatusText = (onlinePayment) => _.get(onlinePayment, ["status", "text"], "");
export const getOnlinePaymentAmountFullText = (onlinePayment) =>
  _.get(onlinePayment, ["amount", "full_text"], "");
export const getOnlinePaymentPaidAtText = (onlinePayment) => _.get(onlinePayment, ["paid_at", "text"], "");
export const getOnlinePaymentReference = (onlinePayment) => _.get(onlinePayment, ["reference"], "");
export const getOnlinePaymentRemark = (onlinePayment) => _.get(onlinePayment, ["remark"], "");
